/* Loads checkout integrations when a shopper is likely to use them. */
(function () {
  'use strict';

  var loaded = {};

  function loadModule(key, src, attributes) {
    if (loaded[key]) return loaded[key];

    loaded[key] = new Promise(function (resolve, reject) {
      var existing = document.getElementById(key);
      if (existing) {
        resolve(existing);
        return;
      }

      var script = document.createElement('script');
      script.id = key;
      script.type = 'module';
      script.src = src;
      script.async = true;
      Object.keys(attributes || {}).forEach(function (name) {
        script.setAttribute(name, attributes[name]);
      });
      script.addEventListener('load', function () { resolve(script); }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Unable to load ' + key)); }, { once: true });
      document.head.appendChild(script);
    });

    return loaded[key];
  }

  function loadBreeze() {
    return loadModule('breeze-script-tag', 'https://sdk.breeze.in/electron/241.0.3/index.js', {
      'data-environment': 'release',
      'data-platform': 'shopify',
      'data-enable-external-trackers': 'false',
      'data-enable-snap-tracker': 'false',
      'data-enable-ga': 'false',
      'data-enable-fbp': 'false',
      'data-emit-tracker-events': 'true',
      'data-ga4-measurement-id': 'G-H0JTXJRGG5',
      'data-gaVersion': 'new',
      'ghost-mode': 'false',
      'data-merchantid': 'budli'
    });
  }

  function loadForklift() {
    return loadModule('breeze-cart-script', 'https://sdk.breeze.in/forklift/6.0.1/app.js', {
      'data-access-token': '934f4f1e47b5b4efcf21072b6ab1d441'
    });
  }

  function loadSnapmint() {
    if (loaded.snapmint) return loaded.snapmint;
    loaded.snapmint = new Promise(function (resolve, reject) {
      var existing = document.getElementById('snapmint-script');
      if (existing) {
        resolve(existing);
        return;
      }

      var script = document.createElement('script');
      script.id = 'snapmint-script';
      script.src = 'https://checkout-merchant.snapmint.com/js/v1/6273';
      script.async = true;
      script.addEventListener('load', function () { resolve(script); }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Unable to load Snapmint')); }, { once: true });
      document.body.appendChild(script);
    });
    return loaded.snapmint;
  }

  function whenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout });
    } else {
      window.setTimeout(callback, timeout);
    }
  }

  function addIntentListeners(element, callback) {
    if (!element) return;
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (eventName) {
      element.addEventListener(eventName, callback, { once: true, passive: true });
    });
  }

  function primeProductCheckout() {
    var buyNow = document.getElementById('breezePrimary');
    var stickyBuy = document.getElementById('budliStickyBuy');
    var productForm = document.querySelector('.product-form');

    addIntentListeners(buyNow, loadBreeze);
    addIntentListeners(stickyBuy, loadBreeze);
    addIntentListeners(productForm, function () {
      loadForklift();
      loadSnapmint();
    });

    // Preserve the EMI offer for shoppers who do not interact immediately,
    // while keeping it out of the critical rendering window.
    whenIdle(function () { loadSnapmint(); }, 3200);

    if ('IntersectionObserver' in window && buyNow) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        whenIdle(function () { loadBreeze(); }, 1800);
      }, { rootMargin: '400px 0px' });
      observer.observe(buyNow);
    }
  }

  function init() {
    var isProduct = document.body.classList.contains('template-product');
    var isCart = document.body.classList.contains('template-cart');

    if (isProduct) {
      primeProductCheckout();
      return;
    }

    if (isCart) {
      whenIdle(function () {
        loadBreeze();
        loadForklift();
        loadSnapmint();
      }, 1200);
      return;
    }

    document.addEventListener('pointerdown', function () {
      loadForklift();
    }, { once: true, passive: true });
  }

  window.BudliCheckout = {
    loadBreeze: loadBreeze,
    loadForklift: loadForklift,
    loadSnapmint: loadSnapmint
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
})();
